import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "Distortion",
  description:
    "Choose a configuration from the drop-down menu and listen to the distortion while watching the waveform and spectrum.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0408/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
